export enum StorageKeys {
  ActiveOrganization = 'activeOrganization',
  CallbackUrl = 'callbackUrl',
  Theme = 'theme',
}
